import { categories, providers } from "../variables"

export const CommonCanUpdateDesc = "PA Horses";

export const CommonCanUpdate = (provider?: string, categoryCode?: string): boolean => {
    // Current rule is you can't update for PA Horses
    return !(provider?.toUpperCase() === providers.pa.toUpperCase() &&
        categoryCode?.toUpperCase() === categories.horses.toUpperCase());
}
